import AbstractApi from '@/api/abstracts/AbstractApi'
import PermissionApi from '@/api/services/adjustment/permission/PermissionApi'
import MondayApi from '@/api/services/adjustment/monday/MondayApi'
import RoleApi from '@/api/services/adjustment/role/RoleApi'

/**
 * @property string apiEnd /api/adjustment
 */
export default class AdjustmentApi extends AbstractApi {
  permission(): PermissionApi {
    return new PermissionApi(`${this.apiEnd}/permission`)
  }

  role(): RoleApi {
    return new RoleApi(`${this.apiEnd}/role`)
  }

  monday(): MondayApi {
    return new MondayApi(`${this.apiEnd}/monday`)
  }
}
